module.exports = __webpack_public_path__ + "img/header-engagementRingsFancy@2x.5ce9461.webp";